import { type Stripe } from '@stripe/stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import type { BasePayment } from './BasePayment'
import { type NuxtAxiosInstance } from '@/types/axios'
import {
  PaymentMethodsType,
  type PromptPayPaymentInfo,
  PromptPayPaymentStatus,
  PromptPayPaymentStatusMap,
  PromptPayPaymentStatusValue,
} from '@/view-models/payment'
import * as PaymentService from '@/service/payment'

export class StripePayment implements BasePayment {
  public static instance: StripePayment
  public static stripeCtx: Stripe | null = null

  // eslint-disable-next-line no-useless-constructor
  private constructor() {}

  public static getInstance(): StripePayment {
    if (!StripePayment.instance) {
      StripePayment.instance = new StripePayment()
    }
    return StripePayment.instance
  }

  public static async initialStripe(publicKey: string) {
    try {
      StripePayment.stripeCtx = await loadStripe(publicKey)
    } catch (error) {
      console.error('initial Stripe error: ', error)
    }
  }

  async confirmPromptPayPayment(payload: PromptPayPaymentInfo['info']) {
    try {
      console.log('createPromptPayPayment: ', payload, StripePayment.stripeCtx)
      const response = await StripePayment.stripeCtx?.confirmPromptPayPayment(payload.client_secret, {
        payment_method: {
          billing_details: {
            email: payload.email,
          },
        },
      })

      const status: string = response?.paymentIntent?.status ?? ''

      return {
        success: status === PromptPayPaymentStatus.Succeeded,
        status: PromptPayPaymentStatusMap[status] ?? PromptPayPaymentStatusValue.Error,
        errorMessage: response?.error?.message ?? '',
      }
    } catch (error: any) {
      console.error('Stripe create payment error: ', error)
      return {
        success: false,
        status: PromptPayPaymentStatusValue.Error,
        errorMessage: error.message,
      }
    }
  }

  async createPayment(axios: NuxtAxiosInstance, paymentData: any) {
    const res = await PaymentService.createPayment(axios, { methodType: PaymentMethodsType.PromptPay, payload: paymentData })
    return res
  }

  processPayment(payType: PaymentMethodsType, payload: PromptPayPaymentInfo['info']) {
    if (payType === PaymentMethodsType.PromptPay) {
      return this.confirmPromptPayPayment(payload)
    }
    console.log('Stripe create payment')
  }

  refund() {
    console.log('Stripe refund')
  }

  cancel() {
    console.log('Stripe cancel')
  }

  getPaymentStatus() {
    console.log('Stripe get payment status')
  }

  getPaymentInfo() {
    console.log('Stripe get payment info')
  }
}
